import { render, staticRenderFns } from "./planos.vue?vue&type=template&id=4c0af316&scoped=true&"
import script from "./planos.vue?vue&type=script&lang=js&"
export * from "./planos.vue?vue&type=script&lang=js&"
import style0 from "./planos.vue?vue&type=style&index=0&id=4c0af316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0af316",
  null
  
)

export default component.exports